module.exports = __webpack_public_path__ + "static/media/1.f98222c8.svg";